import { useMutation } from '@tanstack/react-query'
import { adminApis } from 'api'
import { AdminLoginRequestModel } from 'types/admin'

export default function useLogin() {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: (payload: AdminLoginRequestModel) => adminApis.login(payload),
  })

  const onLogin = (payload: AdminLoginRequestModel) => {
    return mutateAsync(payload)
  }

  return { onLogin, isLogin: isPending }
}
